import { cn, platformProps } from "../../lib";
import { Text } from "../../primitives";
import type { TypographyProps } from "./types";
import { typographyVariants } from "./typography.variants";
import { resolveWhiteSpace } from "./white-space";

export const Typography = ({
  variant = "body-md",
  align,
  transform,
  color,
  whiteSpace,
  numberOfLines,
  italic,
  strike,
  className,
  testID,
  ...rest
}: TypographyProps) => {
  const lines = resolveWhiteSpace(whiteSpace, numberOfLines);

  return (
    <Text
      {...platformProps({ testID, slot: "typography" })}
      className={cn(
        typographyVariants({
          variant,
          align,
          transform,
          color,
          whiteSpace: lines.whiteSpace,
          italic,
          strike,
        }),
        className,
      )}
      numberOfLines={lines.numberOfLines}
      {...rest}
    />
  );
};

Typography.displayName = "Typography";
